import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Get Search Summary
 * @param {string} text
 */
const addSearchQuery = (text: string): Promise<void> => {
  return new Promise(async (resolve, reject) => {
    try {
      const tokenId = Cookies.get(AUTH_TOKEN_KEY)
      const URL = routes.SEARCH + '/query'
      const config = {
        headers: {
          Authorization: `Bearer ${tokenId}`,
        },
      }
      const data = { search: text }

      AxiosClient.post(URL, data, config)
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    } catch (err) {
      reject(err)
    }
  })
}
export default addSearchQuery
